import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

//  @desc First Animation
export const EarlyWrapper = ({ children }) => {
  const earlyRef = useRef(null);
  const isInView = useInView(earlyRef, { once: true });

  const mainControls = useAnimation();

  const animationVariant = {
    hidden: { opacity: 0, y: 75 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={earlyRef} style={{ position: 'relative', overflow: 'hidden' }}>
      <motion.div
        variants={animationVariant}
        initial='hidden'
        animate={mainControls}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
